import moment from 'moment';
import "moment/locale/ko";
import React, { useState, useEffect } from 'react';
// import logo from '../logo.svg';

import { fire, getFireDB, getSomeComments, writeComment, numOfOnce } from "../shared/Firebase";
import { toArray } from 'lodash';

import { Form, Input, InputNumber } from 'antd';
import { List, Avatar, Button, Skeleton } from 'antd';
import { Comment, Tooltip } from 'antd';
import { Card } from 'antd';
const { Meta } = Card;

const layout = {
  labelCol: {
    span: 0,
  },
  wrapperCol: {
    span: 22,
  },
};
const validateMessages = {
  required: '${label}을 입력해주세요!',
  types: {
    email: '${label} is not validate email!',
    number: '${label} is not a validate number!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
};

function CommentList() {

  const [initLoading, setInitLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [comments, setComments] = useState([]);
  const [end, setEnd] = useState(false);

  const [form] = Form.useForm();

  useEffect(() => {
    fire();
    getSomeComments()
    .then(querySnapshot =>{
      let arr = [];
      querySnapshot.forEach((doc) => {
        arr.push(doc.data());
      })
      setComments(toArray(arr))
      setInitLoading(false);
    });
  }, []);

  const onLoadMore = () => {
    setLoading(true);

    getSomeComments()
      .then(querySnapshot => {
        let count = 0;
        querySnapshot.forEach((doc) => {
          setComments(comments => [...comments, doc.data()]);
          count += 1;
        })
        if (count < numOfOnce) setEnd(true);
        setLoading(false);
      })
  };

  const loadMore =
      !initLoading && !loading && !end ? (
        <div
          style={{
            textAlign: 'center',
            marginTop: 12,
            height: 32,
            lineHeight: '32px',
          }}
        >
          <Button onClick={onLoadMore}>더 보기</Button>
        </div>
      ) : null;

  const actions = [];    

  const onFinish = values => {

    // confirm
    let result = window.confirm("한 번 제출된 코멘트는 수정과 삭제가 불가능합니다! 제출하시겠습니까?");
    if(!result) return;

    writeComment(values.authorName, values.comment)
    .then((res) => {
      console.log(res);
      alert('제출되었습니다.');
      form.resetFields();

      // dynamic load
      let added = {
        authorName: values.authorName,
        comment: values.comment,
        createdAt: new Date().getTime()
      }
      setComments(comments => [added, ...comments]);
    }).catch((err) => {
      alert(err, '다시 시도해주십시오.');
    });
    console.log(values);
  };
  
  return (
    <>
      <p class="nanummyeongjo docs-normal">
        팬데믹을 함께 살아낸 당신은, ‘지구인을 위한 질병관리본부'를 보고, 과연 어떤 코멘트를 남기고 싶은가?
      </p>
      <Form {...layout} name="complex-form" onFinish={onFinish} validateMessages={validateMessages} form={form}> 
        <Form.Item name={['comment']} label="comment" style={{paddingLeft: 30}}>
          <Input.TextArea placeholder='"                                                            "'
          />
        </Form.Item>

        <Form.Item
          name={['authorName']}
          label="이름"
          rules={[
            {
              required: true,
            },
          ]}
          style={{ float: 'right' }}
        >
          <Input class="nanummyeongjo" placeholder="당신, 관객"/>
        </Form.Item>
        
        <Form.Item layout={{ ...layout.wrapperCol, span: 8, offset: 16 }} style={{paddingLeft: 30}}>
          <Button type="primary" htmlType="submit">
            제출
          </Button>
        </Form.Item>
      </Form>
      <br/><hr/><br/>
      <List
        className="demo-loadmore-list"
        loading={initLoading}
        itemLayout="horizontal"
        loadMore={loadMore}
        dataSource={comments}
        renderItem={item => (
          <Skeleton title={false} loading={item.loading} active>
          <List.Item>
            <Comment
              actions={actions}
              author={item.authorName}
              content={
                <p style={{fontWeight: "bold"}}>
                  {item.comment}
                </p>
              }
              datetime={
                <Tooltip title={moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}>
                  <span>{moment(item.createdAt).fromNow()}</span>
                </Tooltip>
              }
              style={{
                fontSize: "1.1rem"
              }}
            />
            
            {/* <Skeleton title={false} loading={item.loading} active>
              <List.Item.Meta
                title={<a href="https://ant.design">{item.authorName}</a>}
                description={item.comment}
              />
            </Skeleton> */}
          </List.Item>
          </Skeleton>
        )}
      />
    </>
  );
}

export default CommentList;
